<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [class]="pageConfig.isVisibleHelpPage || showDetails ? 'd-none' : ''"
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (sortObject)="getSortItems($event)"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (onShowHelpPage)="onShowHelpPage()"
>
  <!---------------------------------------- Table Content --------------------------------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- logCode -->
        <td class="tw-w-[10%]">
          <td-value
            class="tw-font-medium font-vazir-ui"
            copyToClipboard
            [value]="item?.document?.logCode"
          ></td-value>
        </td>

        <!-- logText -->
        <td
          class="msg-summary tw-text-center"
          [ngClass]="{
            ' tw-cursor-pointer': item?.document?.logText
          }"
        >
          <div
            class="tw-flex-center"
            textPopover
            [parentSelector]="tagName"
            [fullText]="item?.document?.logText"
            [hidePopover]="
              !showParent ||
              pageConfig?.isVisibleHelpPage ||
              pageConfig?.isVisibleAuditPage
            "
          >
            <p
              class="tw-text-gray-500 dark:!tw-text-gray-200 tw-font-normal max-one-row tw-w-[100px] tw-min-w-[100px]"
            >
              {{ item?.document?.logText | checkValue }}
            </p>
          </div>
        </td>

        <!-- status -->
        <td>
          <td-value
            class="font-vazir-ui"
            copyToClipboard
            [value]="item?.document?.status"
          ></td-value>
        </td>

        <!-- startDate -->
        <td>
          <td-value
            type="dateTimeWithSecond"
            [value]="item?.document?.startDate"
          ></td-value>
        </td>

        <!-- endDate -->
        <td>
          <td-value
            type="dateTimeWithSecond"
            [value]="item?.document?.endDate"
          ></td-value>
        </td>

        <!------------------------------- operations -------------------------------->

        <td class="sticky-td">
          <a
            (click)="onDetail(item)"
            class="btn btn-sm tw-ml-3"
            matTooltip="{{ 'common.showDetails' | translate }}"
          >
            <i class="mdi mdi-text-box-search-outline mdi-20px text-info"></i>
          </a>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- details -->
<ng-container *ngIf="showDetails">
  <app-rule-audits-details
    [model]="detailModel"
    (closePage)="onCloseDetail($event)"
  ></app-rule-audits-details>
</ng-container>

<!----------------------------------------- help -------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
